import { useI18n } from '../../contexts/I18nContext';
import type { LeaveStatus } from '../../lib/leaveApi';
import { LEAVE_STATUS_COLOR } from '../../lib/leaveConstants';
import { statusBadgeStyle } from '../tasks/taskConstants';

/**
 * The accent is applied as an inline style, not a Tailwind class: the colour
 * comes from `LEAVE_STATUS_COLOR` at runtime and a class name built from it
 * would be purged out of the production CSS.
 */
export function LeaveStatusBadge({ status }: { status: LeaveStatus }) {
  const { t } = useI18n();
  return (
    <span
      className="ui-badge whitespace-nowrap"
      style={statusBadgeStyle(LEAVE_STATUS_COLOR[status])}
    >
      {t(`leave.status.${status}`)}
    </span>
  );
}
